export default __webpack_public_path__ + "static/media/08.cb2331b0.webp";